import { createUpsell } from '../upsell';
export const K7m6Xc = createUpsell({
    id: 'K7m6Xc',
    desc: 'Fallback upsells sequence',
    seq: ['upsell-fast-food', 'upsell-detox', 'upsell-alcohol', 'upsell-sweet-treats'],
});
